export const BASE_URL = process.env.API_URL;

// STAGE BASE URL
// for debugging against your local dev bailiwik-server repo:
// export const BASE_URL = 'http://localhost:5000'
